export default __webpack_public_path__ + "static/media/christmas-logo.b64e58b0.png";